import { render, staticRenderFns } from "./DwdcqkdjForm.vue?vue&type=template&id=2ea08056&scoped=true"
import script from "./DwdcqkdjForm.vue?vue&type=script&lang=js"
export * from "./DwdcqkdjForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea08056",
  null
  
)

export default component.exports